var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Dcube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61341 2.00656L12.9534 4.34656C13.4601 4.6199 13.4601 5.3999 12.9534 5.67323L8.61341 8.01323C8.22675 8.2199 7.77341 8.2199 7.38675 8.01323L3.04675 5.67323C2.54008 5.3999 2.54008 4.6199 3.04675 4.34656L7.38675 2.00656C7.77341 1.7999 8.22675 1.7999 8.61341 2.00656Z",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40659 7.25329L6.43992 9.27328C6.93992 9.52662 7.25992 10.04 7.25992 10.6V14.4133C7.25992 14.9666 6.67992 15.32 6.18658 15.0733L2.15325 13.0533C1.65325 12.8 1.33325 12.2866 1.33325 11.7266V7.91328C1.33325 7.35995 1.91325 7.00662 2.40659 7.25329Z",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5933 7.25329L9.55999 9.27328C9.05999 9.52662 8.73999 10.04 8.73999 10.6V14.4133C8.73999 14.9666 9.31999 15.32 9.81332 15.0733L13.8467 13.0533C14.3467 12.8 14.6667 12.2866 14.6667 11.7266V7.91328C14.6667 7.35995 14.0867 7.00662 13.5933 7.25329Z",
    stroke: "#808897",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dcube);
export default __webpack_public_path__ + "static/media/3dcube.24d3f98b9d293b3586709ff390c0e72a.svg";
export { ForwardRef as ReactComponent };